// extracted by mini-css-extract-plugin
export var category = "_jv-9";
export var categoryHeader = "_jv-e";
export var container = "_jv-0";
export var group = "_jv-a";
export var groupItems = "_jv-f";
export var groupSeparator = "_jv-j";
export var loading = "_jv-1";
export var noResults = "_jv-3";
export var placeholder = "_jv-2";
export var resultContent = "_jv-5";
export var resultIcon = "_jv-c";
export var resultItem = "_jv-g";
export var resultMeta = "_jv-8";
export var resultSubtitle = "_jv-7";
export var resultSuffix = "_jv-i";
export var resultTitle = "_jv-6";
export var resultsList = "_jv-4";
export var searchGroup = "_jv-d";
export var selected = "_jv-h";
export var subgroup = "_jv-b";